import { useEffect, useRef, useState } from 'react'
import { NoRecords } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Check, Copy, Eye, Search } from 'lucide-react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { WaitingLoader } from '../../hooks/buttonLoad';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { useDebounce } from '../../hooks/debounce';
import { useGetTicketList } from './api/supportapi';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useToast } from '../../hooks/usetoast';
import { useModalContext } from '../../contexts/ModalContext';
import 'react-photo-view/dist/react-photo-view.css';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';

function SupportTicket() {

    const navigate = useNavigate();
    const toast = useToast();
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const [type, setType] = useState("all");
    const [status, setStatus] = useState(1);
    const [userEmail, setUserEmail] = useState(false);
    const { theme } = useModalContext()


    useEffect(() => {
        if (status === 1) {
            setType("all");
        } else if (status === 2) {
            setType("new");
        } else if (status === 3) {
            setType("pending");
        } else {
            setType("closed");
        }
    }, [status]);


    const handleView = (id, userId) => {
        return navigate(`/ticket-details/${id}/${userId}`)
    }
    const searchtrans = useDebounce(search);


    const { data: getsupportlist, isLoading } = useGetTicketList({
        page: searchtrans ? 0 : tempPage,
        size: tempRows,
        search: searchtrans,
        type: type
    })

    const totalRecords = getsupportlist?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });


    const copyUserEmailAddress = async data => {
        setUserEmail(data._id)
        await copyToClipboard(data?.userEmail)
        toast.success("Email Address copied")
        setTimeout(() => {
            setUserEmail()
        }, 800)
    }
    const statusColor = (status) => status === "Closed" ? "red" : status === "pending" ? "orange" : "green";



    const list = () => {
        if (isLoading) {
            return <WaitingLoader />
        }
        else
            if (getsupportlist?.data?.data?.length > 0) {
                return <>


                    <div style={{ minHeight: "60vh" }}>
                        <div className='table-responsive'>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ maxWidth: "60px" }} align='center'>
                                            S.NO
                                        </TableCell>
                                        <TableCell align='center'>Ticket Id</TableCell>
                                        <TableCell align='center'>User Name</TableCell>
                                        <TableCell align='center'>Email</TableCell>
                                        <TableCell align='center'>category</TableCell>
                                        <TableCell align='center'>Subject</TableCell>
                                        <TableCell align='center'>Status</TableCell>
                                        <TableCell align='center'>Date & Time</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {getsupportlist?.data?.data?.map((row, i) => (
                                        <TableRow key={row._id}>
                                            <TableCell align='center'>{page * rowsPerPage + (i + 1)}</TableCell>
                                            <TableCell align='center'>#{row?.ticketId} </TableCell>
                                            <TableCell align='center'>{row?.userName} </TableCell>
                                            <TableCell align="center">
                                                {row?.userEmail || "-"}
                                                {row?.userEmail && userEmail !== row._id && (
                                                    <Copy
                                                        onClick={() => copyUserEmailAddress(row)}
                                                        size={20}
                                                        className='ml-5'
                                                        style={{
                                                            cursor: "pointer",
                                                            marginLeft: "5px",
                                                            color: theme ? "white" : "black"
                                                        }}
                                                    />
                                                )}
                                                {row?.userEmail && userEmail === row._id && (
                                                    <Check
                                                        size={20}
                                                        style={{
                                                            marginLeft: "5px",
                                                            color: theme ? "white" : "black"
                                                        }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell align='center'>{row?.category} </TableCell>
                                            <TableCell align='center'>{row?.subject} </TableCell>
                                            <TableCell align='center' style={{
                                                textTransform: "capitalize",
                                                color: statusColor(row?.status)
                                            }}>
                                                {row?.status}
                                            </TableCell>

                                            <TableCell align='center'>{moment(row.updatedAt).format("DD/MM/YYYY | hh:mm  a")}</TableCell>
                                            <TableCell >
                                                <Eye className="mx-3" size={20} type='button' onClick={() => handleView(row.ticketId, row._id)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                    <BreadcrumbPagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        totalPages={totalPages}
                        totalRecords={totalRecords}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </>
            }

            else {
                return <NoRecords />
            }
    }


    const checkAdminMutation = useCheckAdminAccess()
    const [access, setAccess] = useState(true);

    useEffect(() => {


        checkAdminAccess()
    }, [access]);

    const checkAdminAccess = async () => {
        const obj = {
            page: "Support Ticket"
        }
        const checkAdminRes = await checkAdminMutation.mutateAsync(obj)
        if (checkAdminRes.status === true) {
            if (checkAdminRes.role === "all") {
                setAccess(true);
            } else {
                setAccess(checkAdminRes.otherData)
            }
        } else if (checkAdminRes.statusCode === 440) {
            logout()
        }
    }

    const feeTypes = { 1: "All", 2: "New", 3: "Pending", 4: "Closed" };

    return (
        <div>
            {access ?
                <>
                    <h4>Support Ticket List</h4>
                    <div className="ad_pg_bx bg-white p-4">
                        <div className='d-flex justify-content-between align-items-center mb-2'>
                            <div className='col-md-4'>
                                <div className="input-group">
                                    <span className="input-group-icon">
                                        <Search size={20} color='#aaa9a9' />
                                    </span>
                                    <input
                                        type="text"
                                        ref={inputRef}
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="form-control"
                                        placeholder="Search TicketId"
                                        value={search}
                                    />
                                </div>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div className="dropdown fltrDop">
                                    <UncontrolledDropdown>
                                        <DropdownToggle caret>
                                            <span>{feeTypes[status]}</span> {/* Show the selected type dynamically */}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem onClick={() => setStatus(1)}>
                                                All
                                            </DropdownItem>
                                            <DropdownItem onClick={() => setStatus(2)}>
                                                New
                                            </DropdownItem>
                                            <DropdownItem onClick={() => setStatus(3)}>
                                                Pending
                                            </DropdownItem>
                                            <DropdownItem onClick={() => setStatus(4)}>
                                                Closed
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </div>
                        {list()}
                    </div>
                </>
                :
                <PermissionDenied />
            }
        </div>
    )
}

export default SupportTicket